(() => {
  if (typeof window.customElements.get('product-variant-option-slider') !== 'undefined') {
    return;
  }

  window.customElements.define(
    'product-variant-option-slider',
    class ProductVariantOptionSlider extends HTMLElement {
      constructor() {
        super();

        this.swiperContainer = this.querySelector('[data-product-variant-option-slider-container]');

        this.initProductVariantOptionSlider();
      }

      initProductVariantOptionSlider() {
        try {
          this.setupSwiper();
        } catch (error) {
          console.error('There was a problem with the ProductVariantOptionSlider component:', error);
        }
      }

      setupSwiper() {
        if (!this.swiperContainer) {
          return;
        }

        const optionSwiper = new Swiper(this.swiperContainer, {
          slidesPerView: 'auto',
          spaceBetween: 4,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          on: {
            init: (swiper) => {
              const checkedInput = this.querySelector('input[type="radio"]:checked');

              if (checkedInput) {
                const swiperWrapper = this.swiperContainer.querySelector('.swiper-wrapper');

                if (swiperWrapper) {
                  const checkedSlide = checkedInput.closest('.swiper-slide, .custom-swiper-slide');

                  if (checkedSlide) {
                    const slides = Array.from(swiperWrapper.children);
                    const slideIndex = slides.indexOf(checkedSlide);

                    if (slideIndex !== -1) {
                      swiper.slideTo(slideIndex, 0);
                    }
                  }
                }
              }
              
              setTimeout(() => {
                this.toggleNavigationArrows(swiper);
              }, 0);
            },
            resize: (swiper) => {
              this.toggleNavigationArrows(swiper);
            },
            update: (swiper) => {
              this.toggleNavigationArrows(swiper);
            }
          }
        });

        return optionSwiper;
      }

      toggleNavigationArrows(swiper) {
        const nextButton = this.querySelector('.swiper-button-next');
        const prevButton = this.querySelector('.swiper-button-prev');
        
        if (!nextButton || !prevButton) {
          return;
        }

        const needsScrolling = swiper.wrapperEl.scrollWidth > swiper.width;
        
        if (needsScrolling) {
          nextButton.style.display = '';
          prevButton.style.display = '';
        } else {
          nextButton.style.display = 'none';
          prevButton.style.display = 'none';
        }
      }
    }
  );
})();